// extracted by mini-css-extract-plugin
module.exports = {"root":"InfiniteScrollLoader__root___NOkIP","compact":"InfiniteScrollLoader__compact___aAk4c"};